import { colors } from '@kmns-internal/furikake/tokens'
import { Typography } from '@mui/material'
import { ReportStatusKey } from 'src/features/monitoringDashboardAlpha/types'
import { ExhaustiveError } from 'src/util/error'

/**
 * ステータスごとのセル背景色。
 * L1 のグループ配色と揃える（実施済み系=緑 / 未実施(期限切れ)系=赤 / 期間中・開始前=なし）。
 */
export const statusCellBgColor: Record<ReportStatusKey, string> = {
  implemented: colors.green[0],
  implementedAfterDeadline: colors.green[0],
  notImplementedYet: colors.red[1],
  recordingOverdue: colors.red[1],
  recording: 'transparent',
  duringPeriod: 'transparent',
  notStarted: 'transparent',
}

/**
 * 詳細（L2）のステータス表示（テキストのみ。セル背景色でグループを表す）
 *
 * 「一時保存」はステータスとしては持たせず、レポートリンク側で補足する方針のため、
 * 記録中(一時保存あり)は期間中／未実施に寄せて表示する:
 * - implemented: 実施済み（緑）
 * - implementedAfterDeadline: 期限後実施（緑）
 * - recording: 期間中（一時保存あり → 該当レポート列で補足）
 * - recordingOverdue: 未実施（一時保存あり → 該当レポート列で補足）
 * - notImplementedYet: 未実施（赤）
 * - duringPeriod: 期間中
 * - notStarted: 開始前（グレー）
 */
export const DetailStatusCell = ({ status }: { status: ReportStatusKey }) => {
  switch (status) {
    case 'implemented':
      return (
        <Typography variant="body2" sx={{ color: colors.success.main }}>
          実施済み
        </Typography>
      )
    case 'implementedAfterDeadline':
      return (
        <Typography variant="body2" sx={{ color: colors.success.main }}>
          期限後実施
        </Typography>
      )
    case 'recording':
      return <Typography variant="body2">期間中</Typography>
    case 'recordingOverdue':
      return (
        <Typography variant="body2" sx={{ color: colors.error.main }}>
          未実施
        </Typography>
      )
    case 'notImplementedYet':
      return (
        <Typography variant="body2" sx={{ color: colors.error.main }}>
          未実施
        </Typography>
      )
    case 'duringPeriod':
      return <Typography variant="body2">期間中</Typography>
    case 'notStarted':
      return (
        <Typography variant="body2" sx={{ color: colors.text.secondary }}>
          開始前
        </Typography>
      )
    default:
      throw new ExhaustiveError(status)
  }
}
